export function SpecPathValue({ path, value, specRegex = null }) {
  return <div key={path}>    
    <span className={'text-secondary monospace' + (specRegex && specRegex.test(path) ? ' bg-highlight' : '')}>{path}</span>: <span
    className={'text-info monospace break-word-all'}>{JSON.stringify(value)}</span>
  </div>;
}
